module.exports = __webpack_public_path__ + "assets/word_smart_report_default.ff161932.svg";